import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Zap, Flag, BookOpen, Activity, CheckCircle } from 'lucide-react';
export function Hero() {
  const features = [{
    icon: <FileText className="w-3 h-3" data-id="element-140" />,
    text: '100% PDF'
  }, {
    icon: <Zap className="w-3 h-3" data-id="element-141" />,
    text: 'Acceso en 5 min'
  }, {
    icon: <Flag className="w-3 h-3" data-id="element-142" />,
    text: 'Hecho para Argentina'
  }, {
    icon: <BookOpen className="w-3 h-3" data-id="element-143" />,
    text: '6 Tomos completos'
  }, {
    icon: <Activity className="w-3 h-3" data-id="element-144" />,
    text: 'Evaluación → Retorno Deportivo'
  }, {
    icon: <CheckCircle className="w-3 h-3" data-id="element-145" />,
    text: '3 Bonos incluidos'
  }];
  const stats = ['+300 kinesiólogos confían', '6 Tomos listos', '3 Bonos incluidos', '4,9/5 ⭐'];
  return <section className="w-full bg-[#0a1410] py-8 md:py-24" data-id="element-146">
      <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-147">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-148">
          {/* Brand */}
          <div className="mb-4 md:mb-8" data-id="element-149">
            <span className="text-amber-500 font-bold text-sm tracking-wider" data-id="element-150">
              🦵 RECURSOHUB™
            </span>
          </div>

          {/* Main Headline */}
          <h1 className="md:text-6xl lg:text-7xl text-white mb-2 md:mb-4 font-[700] text-[27px]" data-id="element-151">
            Dominá la rehabilitación de rodilla de punta a punta
          </h1>

          {/* Subheadline */}
          <h2 className="md:text-5xl lg:text-6xl text-amber-500 mb-6 md:mb-10 text-[18px] font-[500] font-[Inter,_sans-serif]" data-id="element-152">
            El mapa exacto para llevar a tu paciente de la camilla al campo de
            juego sin miedo a las recaídas.
          </h2>

          {/* Product Mockup */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.3,
          duration: 0.7
        }} className="mb-6 md:mb-10" data-id="element-153">
            <img src="https://cdn.magicpatterns.com/uploads/3hJ5ECU1Rraz88RnaqUX1x/Diseno_sin_titulo_(46).png" alt="Atlas de la Rodilla — 6 Tomos + 3 Bonos — El pack más completo de rehabilitación" className="max-w-md md:max-w-lg lg:max-w-2xl mx-auto w-full h-auto" data-id="element-154" />
          </motion.div>

          {/* Subtitle */}
          <div className="mb-3 md:mb-6" data-id="element-155">
            <p className="md:text-lg text-amber-500 font-medium text-[14px]" data-id="element-156">
              El sistema N°1 para kinesiólogo, profe de educación física,
              entrenador personal o instructor de gym en Argentina
            </p>
          </div>

          {/* Description */}
          

          {/* Feature Pills */}
          <div className="flex flex-wrap mb-6 md:mb-10 gap-[3px] items-center justify-center" data-id="element-157">
            {features.map((feature, index) => <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            delay: index * 0.1,
            duration: 0.3
          }} className="flex items-center gap-1 bg-[#0f1f17] border border-amber-900/30 rounded-full px-2.5 py-1" data-id="element-158">
                <span className="text-amber-500" data-id="element-159">{feature.icon}</span>
                <span className="text-xs text-gray-300 font-medium" data-id="element-160">
                  {feature.text}
                </span>
              </motion.div>)}
          </div>

          {/* CTA Button */}
          <motion.a href="#elegi-tu-pack" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="inline-block bg-amber-500 hover:bg-amber-600 text-white font-bold text-lg md:text-xl px-8 md:px-12 py-4 md:py-5 rounded-lg mb-4 md:mb-6 transition-colors shadow-lg shadow-amber-500/20 cursor-pointer" data-id="element-161">
            🔴 → QUIERO MI ATLAS AHORA
          </motion.a>

          {/* Trust Line */}
          <p className="text-sm text-gray-400 mb-6 md:mb-12" data-id="element-162">
            🛡️ Garantía 7 días · 🔒 Pago seguro · 💳 Mercado Pago
          </p>

          {/* Stats Bar */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-4 max-w-3xl mx-auto" data-id="element-163">
            {stats.map((stat, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.8 + index * 0.1,
            duration: 0.4
          }} className="bg-[#0f1f17] border border-amber-900/30 rounded-lg p-3 md:p-4" data-id="element-164">
                <p className="text-sm md:text-base font-semibold text-white" data-id="element-165">
                  {stat}
                </p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}